import React from "react";
import cx from "classnames";

import { shape, string, object, arrayOf, array, bool } from "prop-types";

import ArticlePromo from "../ArticlePromo/ArticlePromo.jsx";
import ArrowLink from "../ArrowLink/ArrowLink.jsx";

const propTypes = {
  suppressLeft: bool,
  topBorder: bool,
  results: arrayOf(
    shape({
      id: string,
      key: string,
      contentType: string,
      authors: array,
      location: string,
      date: string,
      authorLabel: string,
      language: string,
      langDir: string,
    }),
  ),
  link: object,
  focusRef: object,
};

const ManualContentListing = (props) => {
  const { topBorder, suppressLeft, results, link, focusRef } = props;

  if (!results || results.length === 0) {
    return null;
  }

  return (
    <section className="component manual-content-listing">
      <ul
        className={cx("manual-content-listing__items", {
          "manual-content-listing__items--top-border": topBorder,
        })}
      >
        {results.map((result, i) => {
          return (
            <li
              key={result.id || result.key || i}
              className={cx("manual-content-listing__item", {
                "manual-content-listing__item--no-meta": suppressLeft,
              })}
              lang={result.language || null}
              dir={result.rtl ? "rtl" : null}
            >
              {!suppressLeft && (
                <div className="manual-content-listing__meta-wrapper">
                  {result.contentType && (
                    <div className="manual-content-listing__type">
                      {result.contentType}
                    </div>
                  )}
                  {((result.authors && result.authors.length > 0) ||
                    result.company) && (
                    <div className="manual-content-listing__author">
                      {result.authors && result.authors.length > 0 && (
                        <span className="manual-content-listing__author-text">
                          {result.authorLabel}{" "}
                          {result.authors.length > 2
                            ? `${result.authors.slice(0, -1).join(", ")}, and ${
                                result.authors[result.authors.length - 1]
                              }`
                            : result.authors.join(" and ")}
                        </span>
                      )}
                      {result.location && (
                        <span className="manual-content-listing__location-text">
                          {result.location}
                        </span>
                      )}
                    </div>
                  )}
                  {result.date && (
                    <div className="manual-content-listing__updated">
                      <span className="manual-content-listing__updated-value">
                        {result.date}
                      </span>
                    </div>
                  )}
                </div>
              )}
              <ArticlePromo
                {...result}
                focusRef={i === 0 ? focusRef : null}
                gtmElementBaseLabel="manual content listing"
              />
            </li>
          );
        })}
      </ul>
      {link && (
        <div className="manual-content-listing__more">
          <ArrowLink
            {...link}
            gtmElementLabel="manual content listing more link"
          />
        </div>
      )}
    </section>
  );
};

ManualContentListing.propTypes = propTypes;
export default ManualContentListing;
